import { lazy, Suspense } from "react"

import { Center, Spinner } from "@chakra-ui/react"
import { Routes, Route, Navigate } from "react-router-dom"

import { AppRoutes } from "components/constants/appRoutes"
import ProtectedComponent from "components/PleaseLoginComp"
import HostRboLayout from "layouts/host-rbo-layout"
import HostLayout from "layouts/hostLayout"
import ListingAllStepLayout from "pages/listing-details-with-step/listing-all-step-layout"

const HostRboMessagesHeaderLayout = lazy(
  () =>
    import(
      /* webpackChunkName: "HostRboMessagesHeaderLayout" */ "layouts/host-rbo-messages-header-layout"
    ),
)

// const HostRboLayout = lazy(
//   () =>
//     import(/* webpackChunkName: "HostRboLayout" */ "layouts/host-rbo-layout"),
// )

const HostRboHeaderLayout = lazy(
  () =>
    import(
      /* webpackChunkName: "HostRboHeaderLayout" */ "layouts/host-rbo-header-layout"
    ),
)

// const ListingAllStepLayout = lazy(
//   () =>
//     import(
//       /* webpackChunkName: "ListingAllStepLayout" */ "pages/listing-details-with-step/listing-all-step-layout"
//     ),
// )

const Reviews = lazy(
  () => import(/* webpackChunkName: "Reviews" */ "pages/reviews"),
)

const SignUp = lazy(
  () => import(/* webpackChunkName: "SignUp" */ "pages/signup"),
)

const DummyCalendar = lazy(
  () =>
    import(
      /* webpackChunkName: "DummyCalendar" */ "pages/dummy/property-calendar"
    ),
)

const ResetPassword = lazy(
  () =>
    import(
      /* webpackChunkName: "ResetPassword" */ "components/reset-password/reset-password"
    ),
)
const CreatePassword = lazy(
  () =>
    import(/* webpackChunkName: "CreatePassword" */ "pages/create-password"),
)

const VerifyProfile = lazy(
  () => import(/* webpackChunkName: "VerifyProfile" */ "pages/verify-profile"),
)

const ListingDetailsWithLocation = lazy(
  () =>
    import(
      /* webpackChunkName: "ListingDetailsWithLocation" */
      "pages/listing-details-with-step/src/listing-details/listing-details-with-location/listing-details-with-location"
    ),
)

const ListingDetailsWithPricing = lazy(
  () =>
    import(
      /* webpackChunkName: "ListingDetailsWithPricing" */
      "pages/listing-details-with-step/src/listing-details/listing-details-with-pricing/listing-details-with-pricing"
    ),
)

const ListingDetailsWithAvailability = lazy(
  () =>
    import(
      "pages/listing-details-with-step/src/listing-details/listing-details-with-availability/listing-details-with-availability"
    ),
)

const ListingDetailsWithPdp = lazy(
  () =>
    import(
      /* webpackChunkName: "ListingDetailsWithPdp" */
      "pages/listing-details-with-step/src/listing-details/listing-details-with-pdp/listing-details-with-pdp"
    ),
)

const ListingDetailsWithCancellationPolicy = lazy(
  () =>
    import(
      /* webpackChunkName: "ListingDetailsWithCancellationPolicy" */
      "pages/listing-details-with-step/src/listing-details/listing-details-with-cancellation-policy/listing-details-with-cancellation-policy"
    ),
)

const ListingDetailsWithMinimumAge = lazy(
  () =>
    import(
      /* webpackChunkName: "ListingDetailsWithMinimumAge" */
      "pages/listing-details-with-step/src/listing-details/listing-details-with-minimum-age/listing-details-with-minimum-age"
    ),
)

const ListingDetailsWithCalendarSync = lazy(
  () =>
    import(
      /* webpackChunkName: "ListingDetailsWithCalendarSync" */
      "pages/listing-details-with-step/src/listing-details/listing-details-with-calendar-sync/listing-details-with-calendar-sync"
    ),
)

const ListingDetailsWithCongratulations = lazy(
  () =>
    import(
      /* webpackChunkName: "ListingDetailsWithCongratulations" */
      "pages/listing-details-with-step/src/listing-details/listing-details-congratulations/listing-details-congratulations"
    ),
)

const ListingDetailsWithStep5 = lazy(
  () =>
    import(
      /* webpackChunkName: "ListingDetailsWithStep5" */
      "pages/listing-details-with-step/src/listing-details/listing-details-with-step5/listing-details-with-step5"
    ),
)
const ReviewAndPublishListing = lazy(
  () =>
    import(
      /* webpackChunkName: "ReviewAndPublishListing" */
      "pages/listing-details-with-step/src/review-and-publish-listing/review-and-publish-listing"
    ),
)
const VerifyEmailIndex = lazy(
  () =>
    import(
      /* webpackChunkName: "VerifyEmailIndex" */ "pages/verify_email/verify_email"
    ),
)
const WhimstayManagementPage = lazy(
  () =>
    import(
      /* webpackChunkName: "WhimstayManagementPage" */
      "components/sign-up-rbo/create-password-flow/property-management-page"
    ),
)
const ImportingListing = lazy(
  () =>
    import(
      /* webpackChunkName: "ImportingListing" */ "pages/importing-listing"
    ),
)
const Messages = lazy(
  () => import(/* webpackChunkName: "Messages" */ "pages/messages"),
)
const ManageQuickReplies = lazy(
  () =>
    import(
      /* webpackChunkName: "ManageQuickReplies" */ "pages/manage-quick-replies"
    ),
)
const ScheduledMessages = lazy(
  () =>
    import(
      /* webpackChunkName: "ScheduledMessages" */ "pages/scheduled-messages"
    ),
)
const EarningProgress = lazy(
  () =>
    import(
      /* webpackChunkName: "EarningProgress" */ "pages/reports/earning-progress"
    ),
)
const Reservations = lazy(
  () =>
    import(/* webpackChunkName: "Reservations" */ "pages/reports/reservations"),
)
const PayoutReports = lazy(
  () => import(/* webpackChunkName: "PayoutReports" */ "pages/reports/payout"),
)
const PaidOutExpectedDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "PaidOutExpectedDetails" */ "pages/reports/earning-progress/paidout-expected-details"
    ),
)

const PayoutSettings = lazy(
  () =>
    import(
      /* webpackChunkName: "PayoutSettings" */ "pages/profile/payout-settings"
    ),
)
const ProfileDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ProfileDetails" */ "pages/profile/profile-details"
    ),
)

const Loader = () => (
  <Center p={4} h='90vh'>
    <Spinner />
  </Center>
)

const Router = () => (
  <Routes>
    <Route path={AppRoutes.DUMMY} element={<DummyCalendar />} />

    <Route
      path={AppRoutes.RESET_PASSWORD}
      element={
        <HostLayout>
          <Suspense fallback={<Loader />}>
            <ResetPassword />
          </Suspense>
        </HostLayout>
      }
    />

    <Route
      path={AppRoutes.CREATE_PASSWORD}
      element={
        <HostLayout>
          <Suspense fallback={<Loader />}>
            <CreatePassword />
          </Suspense>
        </HostLayout>
      }
    />

    <Route
      path={AppRoutes.HOME}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <ImportingListing />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.SIGN_UP_RBO}
      element={
        <Suspense fallback={<Loader />}>
          <HostRboHeaderLayout>
            <SignUp />
          </HostRboHeaderLayout>
        </Suspense>
      }
    />

    <Route
      path={AppRoutes.VERIFY_EMAIL}
      element={
        <Suspense fallback={<Loader />}>
          <HostRboHeaderLayout>
            <VerifyEmailIndex />
          </HostRboHeaderLayout>
        </Suspense>
      }
    />

    <Route
      path={AppRoutes.VERIFY_PROFILE}
      element={
        <ProtectedComponent>
          <Suspense fallback={<Loader />}>
            <HostRboHeaderLayout>
              <VerifyProfile />
            </HostRboHeaderLayout>
          </Suspense>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.LISTING_MANAGEMENT}
      element={
        <HostRboLayout>
          <Suspense fallback={<Loader />}>
            <WhimstayManagementPage />
          </Suspense>
        </HostRboLayout>
      }
    />

    <Route
      path={AppRoutes.LISTING_DETAILS_LOCATION}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithLocation />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.LISTING_DETAILS_PRICING}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithPricing />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.LISTING_DETAILS_AVAILABILITY}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithAvailability />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.LISTING_DETAILS_PDP}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithPdp />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />
    <Route
      path={AppRoutes.LISTING_DETAILS_CANCELLATION_POLICY}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithCancellationPolicy />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />
    <Route
      path={AppRoutes.LISTING_DETAILS_MINIMUM_AGE}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithMinimumAge />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.LISTING_DETAILS_CALENDAR_SYNC}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithCalendarSync />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.LISTING_DETAILS_CONGRATULATIONS}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithCongratulations />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.LISTING_DETAILS_ADD_VIDEO}
      element={
        <ProtectedComponent>
          <ListingAllStepLayout>
            <Suspense fallback={<Loader />}>
              <ListingDetailsWithStep5 />
            </Suspense>
          </ListingAllStepLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.REVIEW_PUBLISH_LISTING}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <ReviewAndPublishListing />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.MESSAGES}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <Messages />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.REVIEWS}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <Reviews />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.MANAGE_QUICK_REPLIES}
      element={
        <ProtectedComponent>
          <Suspense fallback={<Loader />}>
            <HostRboMessagesHeaderLayout>
              <ManageQuickReplies />
            </HostRboMessagesHeaderLayout>
          </Suspense>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.SCHEDULED_MESSAGES}
      element={
        <ProtectedComponent>
          <Suspense fallback={<Loader />}>
            <HostRboMessagesHeaderLayout>
              <ScheduledMessages />
            </HostRboMessagesHeaderLayout>
          </Suspense>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.PROFILE_DETAILS}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <ProfileDetails />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.PAYOUT_SETTINGS}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <PayoutSettings />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.EARNING_PROGRESS}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <EarningProgress />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.RESERVATIONS}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <Reservations />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.PAYOUT}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <PayoutReports />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route
      path={AppRoutes.PAID_OUT_EXPECTED_REPORT}
      element={
        <ProtectedComponent>
          <HostRboLayout>
            <Suspense fallback={<Loader />}>
              <PaidOutExpectedDetails />
            </Suspense>
          </HostRboLayout>
        </ProtectedComponent>
      }
    />

    <Route path='*' element={<Navigate to={AppRoutes.HOME} replace />} />
  </Routes>
)

export default Router
